import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import Button from "../../../../components/Common/Button/Button";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  archiveClassesActionHandler,
  getUserClassAssignmentActionHandler,
} from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { recallSelective } from "../../../../utils/mainTabs/distribute/recallSelective";
import { recallShotclasses } from "../../../../utils/mainTabs/distribute/recallShotclasses";
import classes from "./RecallSelectiveTable.module.scss";
import { FormattedMessage } from "react-intl";

const RecallSelectiveTable = ({
  tenantName,
  selectedUserClassAndNameObj,
  searchClick,
  setRecallShotclassesSearchClick,
  recallSelectiveResetClick,
}) => {
  const pageSize = 10;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [tableColumns, setTableColumns] = useState([]);
  const { columns } = recallShotclasses;
  const [selectedRowData, setselectedRowData] = useState([]);
  const [loader, setLoader] = useState(false);
  const {
    updatedData,
    totalRows,
    loading,
    handleSetOptionalParams,
    handleCurrentPage,
    setData,
    setUpdatedData,
    handleSearchQuery,
  } = useFetchData(
    (
      searchQuery,
      pageNum,
      pageSize,
      setData,
      setUpdatedData,
      setTotalRows,
      selectedUserClassAndNameObj
    ) =>
      getUserClassAssignmentActionHandler(
        searchQuery,
        pageNum,
        pageSize,
        setData,
        setUpdatedData,
        setTotalRows,
        selectedUserClassAndNameObj?.user
      ),
    pageSize,
    selectedUserClassAndNameObj
  );

  useEffect(() => {
    let newTableColumns = [];
    newTableColumns = recallSelective?.columns(navigate);
    setTableColumns(newTableColumns);
  }, [columns, navigate, location, tenantName]);

  useEffect(() => {
    const dataArr = [];
    updatedData?.forEach((data) => {
      if (data?.checked) dataArr.push(data);
    });
    setselectedRowData(dataArr);
  }, [updatedData]);

  const handleSubmit = () => {
    const userIds = selectedRowData?.map((data) => {
      return data?.UserClassAttemptId;
    });
    setLoader(true);
    dispatch(archiveClassesActionHandler(userIds)).then((response) => {
      setLoader(false);
      if (response.status === 200) {
        handleSearchQuery();
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Shotclasses are Recalled Successfully for Selected Users"
          )
        );
      }
    });
  };

  const onBackClick = () => {
    navigate(recallShotclasses?.path(tenantName));
    setRecallShotclassesSearchClick(1);
    // setRecallShotclassesSearchClick((prev) => prev + 1);
    // handleSetOptionalParams(selectedUserClassAndNameObj);
  };

  useEffect(() => {
    if (searchClick > 0 || recallSelectiveResetClick > 0) {
      handleSetOptionalParams(selectedUserClassAndNameObj);
    }
  }, [searchClick, recallSelectiveResetClick]);

  return (
    <div className={classes.recallSelectiveTable}>
      <div className={classes.header}>
        <div className={classes.text}>
          <span className={classes.classNameText}>
            <FormattedMessage id="CLASS_NAME_TEXT" />:{" "}
          </span>
          {selectedUserClassAndNameObj?.user?.className}
        </div>
        <span className={classes.icon} onClick={onBackClick}>
          <PreviousIcon fill={colors.theme} /> <FormattedMessage id="BACK" />
        </span>
      </div>

      {updatedData?.length === 0 && !loading ? (
        <BoxLayout>
          <div className={classes.noRecordFound}>
            <FormattedMessage id="DISRTIBUTE_NORESULT_TEXT" />
          </div>
        </BoxLayout>
      ) : (
        <DataTable
          columns={tableColumns}
          data={updatedData}
          totalRows={totalRows}
          loading={loading}
          uniqueFieldName={"UserClassAttemptId"}
          selectableRows
          fetchMoreData={handleCurrentPage}
          setDefaultData={setData}
          setData={setUpdatedData}
        />
      )}
      <div className={classes.recallBtn}>
        <Button
          type="submit"
          label={<FormattedMessage id="ARCHIVE_TEXT" />}
          dark
          width="11"
          height="5"
          disabled={selectedRowData?.length === 0}
          backgroundColor={loader ? undefined : "#D31B61"}
          loading={loader}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default RecallSelectiveTable;
